import { useQuery } from "@tanstack/react-query";
import { getPostTagById } from "../../../api/apiBlog";
import i18next from "i18next";

export const useGetPostTagById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["post-tag", id, i18next.language],
        queryFn: () => getPostTagById(id),
        enabled: !!id,
    });

    return {
        tag: data?.data,
        isLoading,
        error,
        refetch,
    };
};
